import { useContext } from "react";
import { actionTab, FormDataContext } from "../context";

type Tab = {
    label: string,
    value: string
}

export function TabSection() {

    const { activeTab, setActiveTab, dataAsset } = useContext(FormDataContext)

    const tabs: Tab[] = [
        { label: "GENERAL ASSET INFORMATION", value: "general" },
        { label: "PROFILE", value: "profile" },
        { label: "DEPRECIATION", value: "depreciation" },
        { label: "MAINTENANCE", value: "maintenance" },
        { label: "PICTURE", value: "picture" },
        { label: "USAGE", value: "usage" },
        { label: "HISTORY", value: "histori" },
    ]


    return (
        <div className="flex overflow-auto gap-1">
            {/* Tab General Asset Information */}
            <div className="w-[34%] border border-[#dadada] dark:border-[#3c3c3c]">
                <button
                    type="button"
                    className={`
                        ${activeTab.value === "general" ? "bg-primary dark:text-black" : "bg-[#3c3c3c]"} 
                        px-4 py-2 w-full text-white dark:text-white text-[11px] text-left`
                    }
                    onClick={() =>
                        setActiveTab((prev: actionTab): actionTab => ({
                            ...prev,
                            value: "general"
                        }))
                    }
                >
                    <b>GENERAL ASSET INFORMATION</b>
                </button>
            </div>

            {/* Other Tabs */}
            <div className="flex w-[66%]">
                {tabs
                    .filter((tab) => tab.value !== "general")
                    .map((tab, index) => {
                        const isDisabledTab = Boolean(!dataAsset?.asset_id)
                        const isDisabledUsageTab = Boolean(tab.value === "usage" && !dataAsset?.asset_infodepreciation_id)

                        return (
                            <button
                                key={index}
                                type="button"
                                className={`
                                ${activeTab.value === tab.value ? "bg-primary dark:text-black" : "bg-[#3c3c3c]"} 
                                px-4 py-2 w-full mr-0.5 text-white dark:text-white text-[11px]`
                                }
                                disabled={isDisabledTab || isDisabledUsageTab}
                                onClick={() =>
                                    setActiveTab((prev: actionTab): actionTab => ({
                                        ...prev,
                                        value: tab.value as actionTab["value"]
                                    }))
                                }
                            >
                                <b>{tab.label}</b>
                            </button>
                        )
                    })}
            </div>
        </div>
    );
}